module.exports = __webpack_public_path__ + "static/media/background-1.67e5c715.jpg";